import { IconSearch } from "@tabler/icons-react";
import styles from "./Support.module.css";

export default function SupportHero({ search, onSearchChange }) {
  return (
    <div className={styles.hero}>
      <div className={styles.heroInner}>
        <div>
          <div className={styles.heroEyebrow}>We're here to help</div>
          <h2 className={styles.heroTitle}>How can we help you today?</h2>
          <p className={styles.heroSub}>
            Browse common questions, report an issue, or get in touch with our
            team. We typically respond within a few hours.
          </p>
        </div>
      </div>
    </div>
  );
}
